import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Paper, BottomNavigation, BottomNavigationAction } from '@mui/material';
import {
    Dashboard as DashboardIcon,
    Business as BusinessIcon,
    Map as MapIcon,
    Inventory as InventoryIcon,
    Person as PersonIcon
} from '@mui/icons-material';

const BottomNav = () => {
    const navigate = useNavigate();
    const location = useLocation();

    return (
        <Paper
            sx={{
                position: 'fixed',
                bottom: 0,
                left: 0,
                right: 0,
                zIndex: 1000,
                borderRadius: '16px 16px 0 0',
                boxShadow: '0px -2px 10px rgba(0,0,0,0.1)'
            }}
            elevation={3}
        >
            <BottomNavigation
                value={location.pathname}
                onChange={(event, newValue) => {
                    navigate(newValue);
                }}
                showLabels
                sx={{
                    height: 70,
                    '& .MuiBottomNavigationAction-root': {
                        color: 'text.secondary',
                        '&.Mui-selected': {
                            color: 'primary.main'
                        }
                    }
                }}
            >
                <BottomNavigationAction
                    label="Dashboard"
                    value="/dashboard"
                    icon={<DashboardIcon />}
                />
                <BottomNavigationAction
                    label="Companies"
                    value="/companies"
                    icon={<BusinessIcon />}
                />
                <BottomNavigationAction
                    label="Zones"
                    value="/zones"
                    icon={<MapIcon />}
                />
                <BottomNavigationAction
                    label="Assets"
                    value="/assets"
                    icon={<InventoryIcon />}
                />
                <BottomNavigationAction
                    label="Profile"
                    value="/profile"
                    icon={<PersonIcon />}
                />
            </BottomNavigation>
        </Paper>
    );
};

export default BottomNav;